import { t } from "@lingui/macro";
import { ArrowRight } from "@phosphor-icons/react";
import { Button } from "@reactive-resume/ui";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import { useAuthStore } from "@/client/stores/auth";

export const MidCTASection = () => {
  const isLoggedIn = useAuthStore((s) => !!s.user);

  return (
    <section className="relative overflow-hidden bg-primary py-16 sm:py-20">
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0.1),transparent_70%)]"
      />

      <motion.div
        className="container relative flex flex-col items-center gap-6 text-center"
        viewport={{ once: true }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
      >
        <h2 className="text-2xl font-bold tracking-tight text-primary-foreground sm:text-3xl">
          {t`Build your ATS-optimized resume in under 30 minutes`}
        </h2>
        <p className="max-w-xl text-base text-primary-foreground/75">
          {t`AI writing, ATS scoring, job matching, and cover letters. Everything you need in one builder. Start with a 3-day free trial.`}
        </p>
        <Button asChild size="lg" variant="secondary" className="text-base font-semibold">
          {isLoggedIn ? (
            <Link to="/dashboard">
              {t`Go to Dashboard`}
              <ArrowRight className="ml-2" weight="bold" />
            </Link>
          ) : (
            <Link to="/auth/register">
              {t`Start 3-day trial`}
              <ArrowRight className="ml-2" weight="bold" />
            </Link>
          )}
        </Button>
      </motion.div>
    </section>
  );
};
